import { TemplatePage } from './types';

const twitterPage: TemplatePage = {
  header: {
    color: '#8AD6FA',
    icon: 'images/video-templates/twitter.jpg',
    title: 'Twitter Video Templates Collection',
    title_meta: '300+ Customizable Twitter Video Template',
    description_meta:
      'Spice up your tweets with Wave.video’s collection of eye-catching customizable Twitter video templates.',
    description:
      'Spice up your tweets with this collection of eye-catching customizable Twitter video templates. Grow your ' +
      'following and expand your reach on the platform with ease.'
  },
  footer: {
    category: 'Twitter',
    description:
      'Creating thumb-stopping videos for social media has never been easier with Wave.video’s collection of editable ' +
      'Twitter video templates. Just pick a template that suits your needs, customize it to your taste, and download ' +
      'the result to your computer or share it directly on a social platform of your choice. Fast and simple!'
  },
  content: [
    {
      type: 'templates',
      title: 'Twitter video templates',
      search: {
        name: 'twitter'
      }
    },
    {
      type: 'stocks',
      title: 'twitter',
      search: { name: 'twitter' }
    },
    { type: 'calendar' }
  ]
};

export default twitterPage;
